/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon24Solid = forwardRef('AttachPaperclipIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14.323 4.122a4.79 4.79 0 1 1 6.774 6.774l-8.416 8.417a6.56 6.56 0 0 1-9.277-9.277l5.888-5.889a1.25 1.25 0 0 1 1.768 1.768l-5.888 5.889a4.06 4.06 0 1 0 5.74 5.741l8.418-8.417A2.29 2.29 0 0 0 16.09 5.89l-8.404 8.404a.52.52 0 1 0 .735.736l5.876-5.877a1.25 1.25 0 0 1 1.768 1.768l-5.876 5.876a3.02 3.02 0 0 1-4.27-4.27l8.403-8.405Z" })));
});
